
import "./home.css";

import WidgetLg from "../../components/widgetLg/WidgetLg";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";

export default function  Home()   {
  return (
      <div>
    <Topbar />
    <div className="container">

    <Sidebar />

    <div className="home">
      <div className="homeWidgets">
        <WidgetLg/>
      </div>
      
    </div>
    </div>
    <p> {localStorage.getItem('token')}</p>
    </div>
  );
}
